import React from 'react';
import CameraCapture from './CameraCapture';

interface Props {
  onCapture: (blob: Blob) => void;
  disabled?: boolean;
}

const SelfieCapture = ({ onCapture, disabled }: Props) => (
  <CameraCapture
    onCapture={onCapture}
    disabled={disabled}
    facingMode="user"
    width={640}
    height={480}
    mirror
    showOverlay
    previewObjectFit="cover"
    altText="Captured selfie"
  />
);

export default SelfieCapture;
